import React from "react"

import { detect } from "detect-browser"
import PropTypes from "prop-types"

import Main from "./atoms/main"
import Alert from "./molecules/alert"
import Footer from "./organisms/footer"
import Header from "./organisms/header"
import "../styles/theme.scss"

const Layout = ({
  children,
  pageType,
  currentVertical,
  customHeader,
  color,
  fullscreen,
}) => {
  let structure = fullscreen ? (
    <Main fullscreen color={color} custom={!!customHeader}>
      {children}
    </Main>
  ) : (
    <>
      <Header
        pageType={pageType}
        currentVertical={currentVertical}
        customHeader={customHeader}
        filters={!customHeader && pageType !== "subscribe"}
      />
      <Main color={color} custom={!!customHeader || pageType === "subscribe"}>
        <Alert />
        {children}
      </Main>
      <Footer currentVertical={currentVertical} />
    </>
  )

  if (detect().name === "ie" || detect().name === "msie") {
    structure = (
      <>
        Your browser is not supported. Please upgrade your browser to view this
        website.
      </>
    )
  }

  return structure
}

Layout.propTypes = {
  pageType: PropTypes.string,
  children: PropTypes.node.isRequired,
  currentVertical: PropTypes.string,
  customHeader: PropTypes.object,
  color: PropTypes.string,
  fullscreen: PropTypes.bool,
}

Layout.defaultProps = {
  pageType: "regular",
  currentVertical: "",
  customHeader: null,
  color: "",
  fullscreen: false,
}

export default Layout
